import { useState } from "react";
import { useTranslation } from "react-i18next";
import JsonLd from "@/components/base/JsonLd";

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const items = [
    { q: "faq.q1", a: "faq.a1" },
    { q: "faq.q2", a: "faq.a2" },
    { q: "faq.q3", a: "faq.a3" },
    { q: "faq.q4", a: "faq.a4" },
    { q: "faq.q5", a: "faq.a5" },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: t(item.q),
      acceptedAnswer: {
        "@type": "Answer",
        text: t(item.a),
      },
    })),
  };

  return (
    <section id="faq" className="w-full bg-background-50">
      <JsonLd data={faqSchema} />
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {t("faq.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="space-y-3">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="rounded-2xl border border-background-200 bg-background-100 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900">
                    {t(item.q)}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center text-foreground-500 shrink-0">
                    <i
                      className={`${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      } text-lg transition-transform`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {t(item.a)}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}